import React, { useState } from 'react';
import { 
  Container, 
  Row, 
  Col, 
  Button, 
  Form, 
  Card,
  Modal
} from 'react-bootstrap';
import { 
  FiSearch, 
  FiCalendar, 
  FiFilter, 
  FiPlus 
} from 'react-icons/fi';
import CreateQRCodeForm from '../components/CreateQRCodeForm';
import '../css/QRCodes.css';

const QRCodes = () => {
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [codes] = useState([
    {
      id: 1,
      title: 'Comsense Technologies',
      type: 'Website',
      url: 'https://www.figma.com/design/GOiyyP5jC7TiiFUzHzK5gk/URL-shortner?node-id=4067-11092&p=f&t=g9OZD6D8UFE4uhYz-0',
      createdDate: 'Apr 9, 2025',
      isActive: true
    }
  ]);

  return (
    <Container fluid className="qr-codes-container">
      <Row className="mb-4 align-items-center">
        <Col>
          <h1 className="GeneralSansSemibold fs-24 text-242D35">QR Codes</h1>
        </Col>
        <Col xs="auto">
          <Button 
            variant="success" 
            onClick={() => setShowCreateForm(true)}
            className="br-radius-32 GeneralSansMedium fs-12"
          >
            <FiPlus className="me-2" />
            Create code
          </Button>
        </Col>
      </Row>

      <Row className="mb-4 g-3">
        <Col md={6} lg={4}>
          <div className="search-box">
            <FiSearch className="search-icon" />
            <Form.Control
              type="text"
              placeholder="Search codes"
              className="GeneralSansMedium fs-12"
            />
          </div>
        </Col>
        <Col xs="auto">
          <Button variant="outline-secondary" className="br-radius-32 GeneralSansMedium fs-12">
            <FiCalendar className="me-2" />
            Filter by created date
          </Button>
        </Col>
        <Col xs="auto">
          <Button variant="outline-secondary" className="br-radius-32 GeneralSansMedium fs-12">
            <FiFilter className="me-2" />
            Add filters
          </Button>
        </Col>
      </Row>

      <Row className="mb-4 align-items-center">
        <Col xs="auto">
          <Button variant="outline-secondary" size="sm" className="br-radius-32 GeneralSansMedium fs-12">
            Export
          </Button>
        </Col>
        <Col xs="auto" className="ms-auto">
          <Form.Group className="d-flex align-items-center">
            <Form.Label className="mb-0 me-2 GeneralSansMedium fs-12 text-242D35">Show:</Form.Label>
            <Form.Select size="sm" className="GeneralSansMedium fs-12 br-radius-32" style={{ width: 'auto' }}>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
              <option value="all">All</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row className="g-4">
        {codes.map(code => (
          <Col key={code.id} xs={12}>
            <Card className="qr-code-card">
              <Card.Body className="d-flex p-4">
                <div className="qr-code-preview me-4">
                  <div className="qr-placeholder"></div>
                </div>
                <div className="qr-code-info">
                  <h3>{code.title}</h3>
                  <p>{code.type}</p>
                  <p className="text-A8B0B9 fs-12">{code.url}</p>
                  <div className="meta-info">
                    <span className="me-3">
                      <i className="bi bi-graph-up me-2"></i>
                      Scan data
                    </span>
                    <span>{code.createdDate}</span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <CreateQRCodeForm 
        show={showCreateForm} 
        onHide={() => setShowCreateForm(false)} 
      />
    </Container>
  );
};

export default QRCodes; 